export const SVGGenerationArrowStaticBlue = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="128" height="254" viewBox="0 0 64 64">
            <defs>
                <linearGradient id="playGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stop-color="#0A2F5A"/>
                <stop offset="100%" stop-color="#1A4B8C"/>
                </linearGradient>
                <filter id="playShadow" x="-20%" y="-20%" width="140%" height="140%">
                <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#000000" flood-opacity="0.2"/>
                </filter>
            </defs>
            <g filter="url(#playShadow)">
                <path d="M16,12 Q16,12 16,12 L16,52 Q16,52 16,52 L48,32 Q48,32 48,32 Z" fill="url(#playGradient)" stroke-linejoin="round"/>
            </g>
        </svg>
    )
}